import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITableSize } from "../../../../documaker/domain/format/objects";

export interface ITableSizePropertyEditable {
  tableSize(): IPropertyEditable<ITableSize>;
}

export function instanceOfITableSizePropertyEditable(instance: any): instance is ITableSizePropertyEditable {
  return instance
      && instance.tableSize
      && instanceOfIPropertyEditable<ITableSize>(instance.tableSize());
}
